import axios from './axiosInstance';
import { AxiosResponse } from 'axios';

interface PostFeedbackParams {
  userEmail?: string;
  userId?: string;
  userName?: string;
  subject: string;
  comments: string;
  captchaToken?: string;
}

interface PostFeedbackResponse {
  status: number;
  data?: unknown;
}

const postFeedback = ({
  userEmail,
  userId,
  userName,
  subject,
  comments,
  captchaToken,
}: PostFeedbackParams): Promise<AxiosResponse<PostFeedbackResponse> | void> => {
  const url = `/feedback`;
  return axios
    .post(
      url,
      {
        userEmail,
        userId,
        userName,
        subject,
        comments: comments ? comments.trim() : null,
      },
      {
        headers: {
          ...(captchaToken ? { 'g-recaptcha-response': captchaToken } : {}),
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
    });
};

const feedbackFunctions = {
  postFeedback,
};

export default feedbackFunctions;
